


















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import Tabs from '@/components/Tabs/index.vue'
@Component({
  components: {
    Tabs
  }
})
export default class HeadTabs extends Vue {
  /**
   * tabsArr tab数据
   * tabsActive 当前项
   * rightStatus 是否显示右侧内容
   */
  @Prop() tabsArr!: any[]
  @Prop() tabsActive!: number
  @Prop({ default: false }) rightStatus!: (boolean | string)
  handlClickTabs(idx:number, item:any) {
    this.$emit('on-handl-click-tabs', idx, item)
  }
}
